/**
 * @author mi
 * @date 2019/6/28
 * @project zujuanzaixian
 * @desc 仅适用于 小于 99999 的整数
 */
const wei = ['十', '百', '千', '万', '亿']
const NUM = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
export const uppercaseNumber = (num) => {
  let nums = (num + '').split('')
  nums = nums.map(item => {
    return NUM[item]
  })
  nums = nums.reverse()
  nums = nums.map((item, index) => {
    if (index > 0) {
      return item === '零' ? item : item + wei[index - 1]
    }
    return item
  })
  nums = nums.reverse().join('')
  nums = nums.replace(/(零+)/g, '零').replace(/零$/g, '')
  if (nums.length <= 3) {
    nums = nums.replace(/^(一十)/g, '十')
  }
  return nums
}
